import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// ✅ Import your background image
import logo3 from "../assets/bg.png";
 // if it is logo3.png use "./logo3.png"

export default function Endpage() {
  const location = useLocation();
  const emailFromState = location?.state?.email;
  const emailFromSession =
    typeof window !== "undefined"
      ? sessionStorage.getItem("registeredEmail")
      : null;

  const email = (emailFromState || emailFromSession || "").trim();

  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    console.log("Endpage: received email =", email);
    setMounted(true);
  }, [email]);

  return (
    <div
      style={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 20,

        /** ⭐ FINAL BACKGROUND IMAGE HERE ⭐ **/
        backgroundImage: `url(${logo3})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",

        color: "#e5e7eb",
        fontFamily: "'Inter', system-ui, sans-serif",
      }}
    >
      {/* Glow Background */}
      <div
        style={{
          position: "fixed",
          width: 320,
          height: 320,
          borderRadius: "50%",
          top: -80,
          right: -40,
          pointerEvents: "none",
          opacity: 0.9,
        }}
      />

      {/* Card */}
      <div
        style={{
          width: "100%",
          maxWidth: 420,
          borderRadius: 24,
          padding: "28px 26px 26px",
          boxShadow: "0 25px 50px -12px rgba(0,0,0,0.75)",
          backdropFilter: "blur(14px)",
          background: "rgba(0,0,0,0.55)", 
          transform: mounted ? "translateY(0)" : "translateY(18px)",
          opacity: mounted ? 1 : 0,
          transition: "opacity 0.7s ease-out, transform 0.7s ease-out",
        }}
      >
        {/* Success Badge */}
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 20 }}>
          <div
            style={{
              padding: "4px 14px 4px 4px",
              borderRadius: 999,
              background: "linear-gradient(135deg, rgba(59,130,246,0.18), rgba(56,189,248,0.18))",
              border: "1px solid rgba(148,163,184,0.45)",
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: "50%",
                background: "linear-gradient(135deg, #22c55e, #16a34a)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 0 18px rgba(34,197,94,0.6)",
              }}
            >
              <span style={{ fontSize: 18, color: "white", fontWeight: 700 }}>✓</span>
            </div>
            <span
              style={{
                fontSize: 13,
                fontWeight: 500,
                letterSpacing: 0.4,
                textTransform: "uppercase",
                color: "#e5e7eb",
              }}
            >
              Registration Successful
            </span>
          </div>
        </div>

        <h2
          style={{
            margin: 0,
            fontSize: 28,
            textAlign: "center",
            color: "white",
          }}
        >
          Thank You for Registering
        </h2>

        <p
          style={{
            marginTop: 12,
            marginBottom: 18,
            fontSize: 14,
            lineHeight: 1.6,
            textAlign: "center",
            color: "#d1d5db",
          }}
        >
          We’re excited to have you with us. You’ll receive a confirmation email
          from our team as soon as possible.
        </p>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 6,
            fontSize: 13,
            color: "#d1d5db",
            marginBottom: 18,
          }}
        >
          <div style={{ display: "flex", gap: 8 }}>
            <span style={{ fontSize: 16 }}>•</span>
            <span>Stay tuned for updates regarding the event.</span>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            onClick={() => (window.location.href = "/login")}
            style={{
              padding: "9px 18px",
              borderRadius: 999,
              border: "none",
              cursor: "pointer",
              fontSize: 14,
              fontWeight: 500,
              background: "linear-gradient(135deg, #3b82f6, #0ea5e9)",
              color: "white",
              boxShadow: "0 14px 30px -12px rgba(59,130,246,0.9)",
            }}
          >
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
}
